import CourseSyllabusSection from '../sections/CourseSyllabusSection';
import LearningResultSection from '../sections/LearningResultSection';
import LearningUnitSection from '../sections/LearningUnitSection';

type CourseTeachingTabProps = {
  readOnly?: boolean;
};

const CourseTeachingTab = ({ readOnly = false }: CourseTeachingTabProps) => {
  return (
    <>
      <CourseSyllabusSection readOnly={readOnly} />
      <LearningUnitSection readOnly={readOnly} />
      <LearningResultSection readOnly={readOnly} />
    </>
  );
};

export default CourseTeachingTab;
